import {
  CustomersUser,
  InvoiceList,
  ItemDocumentImageCheckmark,
  CalendarChartAnalyticsBarChart,
} from '@vy/ui-design-system';
import { ReactNode } from 'react';

type NavigateAction = {
  kind: 'navigate';
  path: string;
};

type PlanCreationOptionsAction = {
  kind: 'planCreationOptions';
};

type HomeQuickActionKind = NavigateAction | PlanCreationOptionsAction;

export type HomeQuickAction = {
  label: string;
  icon: ReactNode;
  action: HomeQuickActionKind;
};

export const HOME_QUICK_ACTIONS: HomeQuickAction[] = [
  {
    label: 'Create contract',
    icon: <ItemDocumentImageCheckmark />,
    action: { kind: 'planCreationOptions' },
  },
  {
    label: 'Create invoice',
    icon: <InvoiceList />,
    action: { kind: 'navigate', path: '/invoices/create' },
  },
  {
    label: 'View reports',
    icon: <CalendarChartAnalyticsBarChart />,
    action: { kind: 'navigate', path: '/reports?reportType=All+reports' },
  },
  {
    label: 'Add new customer',
    icon: <CustomersUser />,
    action: { kind: 'navigate', path: '/customers/create' },
  },
];
